<template>
	<p class="type-content" :class="_class" :style="_style" @click="$emit('click', $event)">
		<slot></slot>
	</p>
</template>

<script>
	export default {
		name: 'type-content',
		props: {
			large: {
				type: Boolean,
				default: false		// 默认
			},
			medium: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			left: {
				type: Boolean,
				default: false
			},
			center: {
				type: Boolean,
				default: false
			},
			right: {
				type: Boolean,
				default: false
			},
			weight: {
				type: String,
				default: '300'
			},
			padding: {
				type: String,
				default: '0 0 20px'
			},
			indent: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			_style() {
				let style = '';
				const styleObj = {
					'left': 'text-align: left;',
					'center': 'text-align: center;',
					'right': 'text-align: right;',
					'padding': `padding: ${this.padding};`,
					'weight': `font-weight: ${this.weight};`
				};
				Object.keys(styleObj).forEach(key => {
					if (this[key]) {
						style += styleObj[key];
					}
				});
				if (style.includes('text-align') === false) {
					style += styleObj['left'];
				}
				return style;
			},
			_class() {
				if (this.medium) {
					return this.indent ? 'content-medium-indent' : 'content-medium';
				}
				if (this.small) {
					return this.indent ? 'content-small-indent' : 'content-small';
				}
				return this.indent ? 'content-large-indent' : 'content-large';
			}
		}
	}
</script>

<style scoped lang="less">
	.type-content{
		width: 100%;
		font-weight: 300;
		font-family: 'Montserrat', sans-serif;
		// background-color: green;
	}
	.content-large, .content-large-indent{
		font-size: 18px;
		line-height: 27px;
	}
	.content-large-indent{
		text-indent: 36px;
	}
	.content-medium, .content-medium-indent{
		font-size: 16px;
		line-height: 24px;
	}
	.content-medium-indent{
		text-indent: 32px;
	}
	.content-small, .content-small-indent{
		font-size: 14px;
		line-height: 21px;
	}
	.content-small-indent{
		text-indent: 28px;
	}
</style>
